<script setup lang="ts">
const props = defineProps<{
  title: string;
  columns: { text: string; align: string }[];
  items: any[];
  getTableRowClasses?: (
    index: number,
    isMe: boolean,
  ) => (string | { [key: string]: boolean | undefined })[];
  emptyStateText?: string;
  tableType: 'ranking' | 'prizes';
  bgColor?: string;
  borderColor?: string;
  userItem?: any;
}>();

const { isDesktop } = useLayout();

const tableContainer = ref<HTMLElement>();

defineExpose({
  tableContainer,
});
</script>

<template>
  <div class="flex-1 flex flex-col items-center min-w-[356px]">
    <span
      v-if="isDesktop"
      class="font-bold text-lg mb-4 text-white"
      >{{ props.title }}</span
    >
    <div
      ref="tableContainer"
      class="w-full rounded-lg overflow-hidden p-5 pb-2"
      :style="{
        backgroundColor: props.bgColor,
        borderColor: props.borderColor,
        borderWidth: '1px',
        borderStyle: 'solid',
      }"
    >
      <table class="w-full overflow-hidden">
        <thead>
          <tr>
            <th
              v-for="(column, colIndex) in props.columns"
              :key="`header-col-${colIndex}`"
              :class="[
                'text-[13px] text-white/50 font-bold pb-2.5',
                `text-${column.align}`,
              ]"
              scope="col"
            >
              <span>{{ column.text }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="items.length > 0">
            <tr
              v-for="(item, index) in props.items"
              :key="`row-${index}`"
              :class="[
                'transition h-[38px]',
                index % 2 === 0
                  ? props.tableType === 'ranking'
                    ? 'bg-[#00C9FF]/10'
                    : 'bg-[#232A36]'
                  : 'bg-transparent',
                props.getTableRowClasses
                  ? props.getTableRowClasses(index, item.is_me)
                  : '',
                item.is_me ? 'ring-2 ring-[#00C9FF] ring-inset' : '',
              ]"
            >
              <slot
                :index="index"
                :item="item"
                name="row-content"
                :table-type="props.tableType"
              ></slot>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td
                class="text-center text-white/50 py-8 align-middle"
                :colspan="props.columns.length"
              >
                {{ props.emptyStateText || 'Nenhum item encontrado' }}
              </td>
            </tr>
          </template>
          <template v-if="props.userItem">
            <tr>
              <slot
                :index="props.items.length"
                :is-user="true"
                :item="props.userItem"
                name="row-content"
                :table-type="props.tableType"
              ></slot>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
